import * as Caml_int32 from "bs-platform/lib/es6/caml_int32.js";

function of_sec(x) {
  return x | 0;
}

function of_ms(x) {
  return x / 1000.0 | 0;
}

function to_sec(x) {
  return x;
}

function to_ms(x) {
  return x * 1000.0;
}

function divmod(value, by) {
  var quotient = Caml_int32.div(value, by);
  var remainder = Caml_int32.mod_(value, by);
  return (
    /* tuple */
    [quotient, remainder]
  );
}

function pad(value) {
  if (value < 10) {
    return "0" + String(value);
  } else {
    return String(value);
  }
}

function to_string_HHMMSS(totalSeconds) {
  var match = divmod(totalSeconds, 60);
  var match$1 = divmod(match[0], 60);
  var hours = match$1[0];
  var formattedSeconds = pad(match[1]) + "s";
  var formattedMinutes = pad(match$1[1]) + "m";
  var formattedHours = String(hours) + "h";
  var formattedWithoutHours = formattedMinutes + (":" + formattedSeconds);
  var formattedWithHours = formattedHours + (":" + formattedWithoutHours);

  if (hours !== 0) {
    return formattedWithHours;
  } else {
    return formattedWithoutHours;
  }
}

function of_span_since_epoch(x) {
  return x;
}

function to_span_since_epoch(x) {
  return x | 0;
}

function sub(time, span) {
  return time - span;
}

function diff(x, y) {
  return x - y | 0;
}

var Span = {
  of_sec: of_sec,
  of_ms: of_ms,
  to_sec: to_sec,
  to_ms: to_ms,
  to_string_HHMMSS: to_string_HHMMSS
};
export { Span, of_span_since_epoch, to_span_since_epoch, sub, diff };
/* No side effect */